import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class MoreInfoService {
  public ttsReport: any = ''
  public Data: any = ''
  public DataYard: any = ''
  public DataBay: any = ''
  public vacantData: any = ''

  public ttaReport: any = ''

  constructor() { }

  getData(data) {
    return this.Data = data
  }

  ttsData(data) {
    return this.ttsReport = data
  }

  ttaData(data) {
    return this.ttaReport = data
  }

  getYardData(y) {
    return this.DataYard = y
  }
 
  getBayData(b) {
    return this.DataBay = b
  }

  getVacantData(v) {
    return this.vacantData = v
  }
}